export default __webpack_public_path__ + "static/media/sensotrend_uploader_forgotten_password.b31a3a4a.png";